import { Typography, TypographyProps } from '@material-ui/core';
import React from 'react';
import { memo } from 'react';

interface Props extends TypographyProps {
  value?: string | string[];

  disableTypography?: boolean;
}

export const CostCenterDisplay: React.FC<Props> = memo(({ value, disableTypography, ...props }) => {
  if (!value) return null;

  if (disableTypography) return <>{value}</>;

  return <Typography {...props}>{value}</Typography>;
});
